<template>
	<div class='inputBox'>
    <label class="label">{{label}}</label>
    <label v-if='disabled' class="forInput">{{value}}</label>
		<input v-if='!disabled' :type="secret?'password':'text'" v-bind:style="{ 'height': height }" v-bind:value="value" @input='input($event.target.value)' /> 
		<div class="hintArea">
      <span v-if='!disabled&&value == ""'>{{hintMsg}}</span>
    </div>
    <div v-if='extendType != ""' class="rightExtend" >
      <span v-bind:class="{ lock: extendLock || innerLock }" @click='clickExtend' v-if='extendType == "button"' class="btn radius">{{extendMsg}}</span>
      <img @click='clickExtend' v-if='extendType == "icon"' :src="extendSrc" />
    </div>
	</div>
</template>

<script>
export default {
  data () {
    return {
      //保存上次倒计时秒数
      lastCountDownSeconds: 0,
      //组建内倒计时状态
      innerCountDownSeconds:0,
      //执行器
      interval:null,
      //内部锁
      innerLock:false
    }
  },
	props: {
		//绑定值
		value: {
			type: String,
			default: ""
		},
		//高度
		height: {
			type: String,
			default: ""
		},
		//提示信息
		hintMsg: {
			type: String,
			default: ""
    },
    //标题
    label: {
      type: String,
			default: "默认标题"
    },
    //不能修改
    disabled:{
      type: Boolean,
			default: false
    },
    //拓展类型，两种：icon和button
    extendType:{
      type: String,
			default: ""
    },
    //拓展源，图片对应src，按钮对应文字
    extendSrc:{
      type: String,
			default: ""
    },
    //拓展锁
    extendLock:{
      type: Boolean,
			default: false
    },
    //显示加密
    secret:{
      type: Boolean,
			default: false
    },
    //倒计时秒数
    countDownSeconds:{
      type: Number,
			default: 0
    },
  },
	methods: {
		input(val){
			this.$emit('input', val)
    },
    clickExtend(){
      //启用拓展锁禁止点击
      if(this.extendLock || this.innerLock){
        return
      }
      this.$emit('extendHandler')
      //清空历史倒计时
      this.lastCountDownSeconds = 0
      //上锁
      this.innerLock = true
      //监听倒计时
      this.listen()
    },
    //监听倒计时
    listen(){
      //上锁
      var that = this
      this.interval = setInterval(function(){
        console.log('监听中')
        if(that.countDownSeconds > 0){
          //传入倒计时参数
          if(that.lastCountDownSeconds == 0){
            //设置历史倒计时
            that.lastCountDownSeconds = that.countDownSeconds
            //设置内部倒计时
            that.innerCountDownSeconds = that.countDownSeconds
          }
          else if(that.lastCountDownSeconds == that.countDownSeconds){
            //传入的倒计时没有变化，内部倒计时自减
            if(that.innerCountDownSeconds > 0){
              that.innerCountDownSeconds --
            }
            else{
              //倒计时结束
              //解锁
              that.innerLock = false
              //清除监听
              window.clearInterval(that.interval)
              that.interval = null
            }
          }
          else{
            //传入的倒计时发生变化
            that.lastCountDownSeconds = that.countDownSeconds
            that.innerCountDownSeconds = that.countDownSeconds
            console.log('传入的倒计时发生变化')
          }
        }
        else{
          //没传入解锁
          that.innerLock = false
          //清除监听
          window.clearInterval(that.interval)
          that.interval = null
        }
      },1000)
    }
	},
	computed: {
    extendMsg(){
      if(this.innerCountDownSeconds > 0){
        //传入倒计时秒数并且执行器不为空
        return this.innerCountDownSeconds + '秒'
      }
      else{
        //显示传入值
        return this.extendSrc
      }
    }
	}
}
</script>

<style lang="less" scoped>
	@import "../../assets/theme.less";
	.inputBox{
    position: relative;
    font-size:0.28rem;
    display: flex;
    width: 100%;
    height: 0.9rem;
    padding-left: 0.3rem;
    border-bottom: 1px solid #eeeeee;
    .label{
      color: #333333;
      width: 1.4rem;
      text-align: left;
      margin: auto 0.3rem auto 0;
    }
    .forInput{
      width: 3.6rem;
      color: #333333;
      margin: auto 0;
      text-align: left;
    }
		input{
			height:100%;
			margin:0;
			outline:none;
      border:none;
      width: 3.6rem;
    }
    .hintArea{
      position: absolute;
      height: 0.9rem;
      display: flex;
      left: 2rem;
      //击穿顶层
      pointer-events:none;
      span{
        z-index:999;
        color:#cccccc;
        margin: auto 0;
      }
    }
    .rightExtend{
      margin: auto 0.2rem auto 0;
      display: flex;
      height: 0.9rem;
      flex-grow: 1;
      justify-content: flex-end;
      .btn{
        width: 1.48rem;
        height: 0.5rem;
        margin: auto 0;
        text-align: center;
        background-color: @primaryColor;
        color: #fff;
        font-size:0.24rem;
        padding: 0.05rem 0.1rem;
      }
      .lock{
        background-color: #cccccc;
      }
      img{
        margin: auto 0;
      }
    }
	}
</style>


// WEBPACK FOOTER //
// inputBox.vue?5cd0ccc5